import * as React from "react";
import { SVGProps } from "react";

const Ergo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 58 58"
    {...props}
  >
    <style>{".st0{fill-rule:evenodd;clip-rule:evenodd}"}</style>
    <g id="main">
      <g id="Group-16" transform="translate(0 -1)">
        <g id="Group-15" transform="translate(0 .83)">
          <path
            id="Fill-9"
            d="m11.2 47.8 18.3 7.4 18.2-7.8L55 29.1l-7.8-18.2-18.3-7.3-18.2 7.8-7.3 18.3 7.8 18.1zm18.3 10.8c-.2 0-.4 0-.6-.1L9.3 50.6c-.4-.2-.7-.5-.9-.9L.1 30.3c-.2-.4-.2-.8 0-1.3L8 9.5c.2-.4.5-.7.9-.9L28.3.3c.4-.2.8-.2 1.3 0l19.6 7.9c.3.1.6.4.8.8l8.3 19.4c.2.4.2.8 0 1.3l-7.9 19.6c-.2.4-.5.7-.9.9l-19.4 8.3c-.1.1-.4.1-.6.1z"
            className="st0"
          />
          <path
            id="Fill-10"
            d="m33.4 29.1-7.8 8.6H38v3.8H20.5v-3.8l7.8-8.6-7.8-8.1v-3.7H38V21H25.8z"
            className="st0"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Ergo;
